<template>
  <div style="background:#fff;height:100%"
       v-loading="loading"
       id="project_list_card">
    <Tabs v-model="tabValue"
          v-if="!onlyOnePage">
      <TabPane :label="val.follow_name"
               v-for="(val,ind) in tabList"
               :key='ind'
               :name="val.follow_code">
        <creatTask :selectType='val'
                   :patientInfo='patientInfo' />
      </TabPane>
    </Tabs>

    <creatTask :selectType='patientInfo.type'
               v-else
               :patientInfo='patientInfo' />

  </div>
</template>
<script>
export default {
  name: 'createFollow',
  props: {
    patientInfo: {},
  },
  //   props: {'patientInfo'}
  data() {
    return {
      tabValue: '',
      tabList: [],
      channel: '',
      loading: true,
      onlyOnePage: false,
    }
  },
  components: {
    creatTask: () => import('./creatTask.vue'),
  },
  computed: {
    windowHeight: function () {
      return window.innerHeight
    },
  },
  mounted() {
    console.log(38, this.patientInfo)
    if (this.patientInfo) {
      this.tabValue = this.patientInfo.type.follow_code
      this.loading = false
      this.onlyOnePage = true
    } else {
      this.$utils.caringRequest({
        method: 'get',
        url: this.$utils.getInterface('GETFOLLOWTYPELIST'),
        success: (res) => {
          this.tabList = res.data

          this.loading = false

          // this.tabValue='1280309721538105355'
        },
      })
    }
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.CompletionBox {
  margin: 20px 60px 0 20px;
  background: #f0f6ff;
  padding: 10px 20px;
}
.TableBox {
  padding: 20px;
}
.channelBox {
  border-top: 1px dashed #b8bdc6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px;
  padding: 20px 20px 0 0;
  width: 100%;

  div {
    display: flex;
    flex-direction: column;
  }
}
.weilei {
  line-height: 20px;
  em {
    background: #333333;
    display: inline-block;
    width: 12px;
    height: 12px;
  }
}
.addChannel {
  border: 1px solid #4286f1;
  padding: 6px 16px;
  margin-right: 20px;
  border-radius: 18px;
  color: #4286f1;
}
</style>